import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container mt-3" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "accordion-item" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["data-bs-target", "aria-controls"]
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_7 = { class: "hidden-xs" }
const _hoisted_8 = { class: "btn-group me-3" }
const _hoisted_9 = ["data-bs-target"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_12 = { class: "accordion-body" }
const _hoisted_13 = { class: "strategy-options-form fluid" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = { class: "col-lg-5 col-md-5 col-sm-12" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_18 = { class: "col-lg-5 col-md-5 col-sm-12 offset-lg-1 offset-md-1" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "row mb-3" }
const _hoisted_21 = { class: "col-lg-6 col-md-7 col-sm-12" }
const _hoisted_22 = { class: "form-check form-check-container" }
const _hoisted_23 = { class: "col-lg-5 col-md-5 col-sm-12" }
const _hoisted_24 = { class: "form-check form-check-container" }
const _hoisted_25 = { class: "row strategy-action-buttons justify-content-end" }
const _hoisted_26 = { class: "col-lg-2 col-md-4 col-sm-6" }
const _hoisted_27 = { class: "col-lg-4 col-md-5 col-sm-6" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StrategyCopyComponent = _resolveComponent("StrategyCopyComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "accordion",
        id: `strategy-${_ctx.localStrategy.id}`
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", {
            class: "accordion-header",
            id: `heading-${_ctx.localStrategy.id}`
          }, [
            _createElementVNode("button", {
              class: "accordion-button collapsed",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#collapse-${_ctx.localStrategy.id}`,
              "aria-controls": `collapse-${_ctx.localStrategy.id}`
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.localStrategy.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("i", {
                  class: "fa fa-copy icon-medium",
                  role: "button",
                  "data-bs-toggle": "modal",
                  "data-bs-target": `#copyStrategyModal-${_ctx.localStrategy.id}`,
                  title: "Copy Strategy"
                }, null, 8, _hoisted_9),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa fa-save icon-medium", {
                  'strategy-action-icon--disabled': _ctx.isNameNotValid,
                }]),
                  role: "button",
                  title: "Save Strategy",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (!_ctx.isNameNotValid && _ctx.saveStrategy(true)), ["stop"])),
                  disabled: _ctx.isNameNotValid
                }, null, 10, _hoisted_10),
                _createElementVNode("i", {
                  class: "fa fa-trash icon-medium",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteStrategy && _ctx.deleteStrategy(...args))),
                  role: "button",
                  title: "Delete Strategy"
                })
              ])
            ], 8, _hoisted_5)
          ], 8, _hoisted_4),
          _createElementVNode("div", {
            id: `collapse-${_ctx.localStrategy.id}`,
            class: "accordion-collapse collapse",
            "aria-labelledby": `heading-${_ctx.localStrategy.id}`,
            "data-bs-parent": `#strategy-${_ctx.localStrategy.id}`
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("form", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", {
                        for: "strategyName",
                        class: "form-label"
                      }, "Strategy Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "strategyName",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localStrategy.name) = $event)),
                        maxlength: "40",
                        autofocus: ""
                      }, null, 512), [
                        [_vModelText, _ctx.localStrategy.name]
                      ]),
                      (_ctx.isNameNotValid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Strategy with such name already exists. "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", {
                        for: "priceRounding",
                        class: "form-label"
                      }, "Price Rounding", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        id: "priceRounding",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localStrategy.roundingTypeId) = $event))
                      }, [...(_cache[9] || (_cache[9] = [
                        _createStaticVNode("<option value=\"0\" data-v-0c4097ec>To nearest cent</option><option value=\"1\" data-v-0c4097ec>To nearest dollar</option><option value=\"2\" data-v-0c4097ec>To nearest 99c</option><option value=\"3\" data-v-0c4097ec>To nearest higher dollar</option><option value=\"4\" data-v-0c4097ec>To nearest higher 99c</option>", 5)
                      ]))], 512), [
                        [_vModelSelect, _ctx.localStrategy.roundingTypeId]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "isMultipleWindows",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localStrategy.isMultipleWindows) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.localStrategy.isMultipleWindows]
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "isMultipleWindows"
                      }, " Adjust the price based on number of days-out ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "isAdjustByUtilization",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localStrategy.isAdjustByUtilization) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.localStrategy.isAdjustByUtilization]
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "isAdjustByUtilization"
                      }, " Adjust the price as the tee sheet fills ", -1))
                    ])
                  ])
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "light-divider" }, null, -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["prevent"]))
                    }, " Cancel ")
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.continue2 && _ctx.continue2(...args)), ["prevent"])),
                      disabled: _ctx.isNameNotValid
                    }, [...(_cache[13] || (_cache[13] = [
                      _createTextVNode(" Continue to Pricing Logic ", -1),
                      _createElementVNode("i", {
                        class: "fa fa-caret-right",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_28)
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_11)
        ])
      ], 8, _hoisted_2)
    ]),
    _createVNode(_component_StrategyCopyComponent, {
      Strategy: _ctx.strategy,
      Facilities: _ctx.facilities,
      ExistingStrategies: _ctx.existingStrategies
    }, null, 8, ["Strategy", "Facilities", "ExistingStrategies"])
  ], 64))
}